(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('paginator', function(urlUtils,
            $location,
            scrollService,
            $q,
            analyticsTracker) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            total: '=',
            pageSize: '=',
            currentPage: '=',
            change: '&',
            scrollTarget: '@',
            scrollContainer: '@',
            maxButtons: '@'
        },
        templateUrl: 'partials/home/directivetemplate?type=paginator',
        link(scope) {
            const path = urlUtils.stripLeadingSlash($location.path());
            scope.change = scope.change();

            if (scope.maxButtons === undefined) {
                scope.maxButtons = 7;
            }

            scope.goToPage = function(page, e) {
                if (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                if (scope.currentPage === page) {
                    return;
                }
                scope.currentPage = page;
                analyticsTracker.resetStatus(false);
                const res = $q.when(scope.change(scope.currentPage, e));

                if (scope.scrollTarget) {
                    res.then(() => scrollService.scrollTo(scope.scrollTarget, { duration: 500, animate: true, container: scope.scrollContainer }));
                }
            };

            function preparePages() {
                scope.totalPages = Math.floor((scope.total / scope.pageSize) + 0.999);

                const pageButtons = scope.maxButtons > scope.totalPages ? scope.totalPages : scope.maxButtons;
                const currentPageIndex = scope.currentPage - 1;

                function addPage(pageNo) {
                    return {
                        page: pageNo,
                        isSpacer: false,
                        url: pageNo > 1 ? `${path}?pi=${pageNo - 1}&pt=${scope.totalPages}` : `${path}`,
                        isCurrent: pageNo === scope.currentPage
                    };
                }

                // prepare array of pages
                const pages = [];

                // add first page
                pages.push(addPage(1));

                // add additional pages
                const extraButtons = pageButtons - 2;

                let start = scope.currentPage - Math.floor(extraButtons / 2);
                start = Math.max(start, 2);

                let stop = start + extraButtons - 1;
                stop = Math.min(stop, scope.totalPages - 1);

                start = Math.min(start, stop + 1 - extraButtons);

                for (let page = start; page <= stop; page++) {
                    pages.push(addPage(page));
                }

                // add last page
                if (scope.totalPages > 1) {
                    pages.push(addPage(scope.totalPages));
                }

                // if required, convert second and penultimate page into spacers
                if (pages.length > 2) {
                    if (pages[1].page !== 2) {
                        pages[1].isSpacer = true;
                    }
                    if (pages[pages.length - 2].page !== (scope.totalPages - 1)) {
                        pages[pages.length - 2].isSpacer = true;
                    }
                }

                scope.prevUrl = currentPageIndex > 1
                                ? `${path}?pi=${currentPageIndex - 1}&pt=${scope.totalPages}` : `${path}`;
                scope.nextUrl = currentPageIndex < scope.totalPages
                                ? `${path}?pi=${currentPageIndex + 1}&pt=${scope.totalPages}` : `${path}`;

                scope.pages = pages;
            }

            function updateOnWatch(v) {
                if (v != null && scope.total > 0) {
                    preparePages();
                }
            }

            // watch for external changes to the total
            scope.$watch('total', updateOnWatch);

            scope.$watch('currentPage', updateOnWatch);

            preparePages();
        }
    };
});
})();
